import React, { useEffect, useCallback, useLayoutEffect } from "react"
import { useSelector } from "react-redux"

const initZenDesk = () => {
    window.zESettings = {
        webWidget: {
            offset: {
                horizontal: '50px',
                vertical: '0'
            }
        }
    }

    if(window.zE){
        window.zE('webWidget', 'hide')
        window.zE('webWidget:on', 'open', function(){
            window.zE('webWidget', 'show')
        })
        window.zE('webWidget:on', 'close', function(){
            //	 			window.zE('webWidget', 'hide');
        })
        window.zE('webWidget', 'helpCenter:setSuggestions', { search: 'FAQ' })
    }
}

const loadZenDesk = apiKey => {
    const zenDeskDom = document.getElementById('ze-snippet')
	if (!zenDeskDom) {

        window.initZen = initZenDesk

		const head = document.getElementsByTagName('head')[0]
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.id = 'ze-snippet'
		script.defer = true
		script.async = true
		script.src = `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`
        script.onload = initZenDesk()
		head.appendChild(script)
	}
}

export default Wrapper =>{

    return props =>{
        const global = useSelector(state =>state.global);
        const { config } = global; 

        const handleClick = useCallback(event => {
            event.preventDefault();
            if(window.zE){
                window.zE('webWidget', 'show')
                window.zE('webWidget', 'open')
            }
        }, [])

        useEffect(() => {
            let onlineHelps = null;
            if(config?.support?.zendesk){
                loadZenDesk(config?.support?.zendesk)

                onlineHelps = Array.from(document.getElementsByClassName("onlinehelp"));

                onlineHelps?.forEach((item) =>{
                    item.addEventListener('click', handleClick);
                })
            }

            return () =>{
                onlineHelps?.forEach((item) =>{
                    item?.removeEventListener('click', handleClick);
                })
                onlineHelps = null;
            }
        }, [])


        return <Wrapper {...props} />
    }
}